import { SectorsRepository } from '../repositories/sectors.repository'
import { SectorPayloadT, SectorsGetListResponseT } from '../types/sectors.types'

const sectorsRepository = new SectorsRepository()

export class SectorsService {
    async getList(): Promise<SectorsGetListResponseT> {
        const response = await sectorsRepository.getList()
        return response.data
    }

    async updateSector(sector_id: number, payload: SectorPayloadT): Promise<void> {
        await sectorsRepository.updateSector(sector_id, payload)
    }

    async createSector(payload: SectorPayloadT): Promise<void> {
        await sectorsRepository.createSector(payload)
    }

    async deleteSector(sector_id: number): Promise<void> {
        await sectorsRepository.deleteSector(sector_id)
    }
}
